import { onCleanup, onMount } from "solid-js";

export function RiveGauge(props: { label: string; value: number; max: number; unit?: string }) {
  let svg!: SVGSVGElement;

  onMount(() => {});
  onCleanup(() => {});

  const pct = () => Math.min(1, Math.max(0, props.value / props.max));
  const C = 2 * Math.PI * 42;

  const gaugeColor = () => {
    const p = pct();
    if (p > 0.75) return "var(--color-critical)";
    if (p > 0.5) return "var(--color-warning)";
    return "var(--color-info)";
  };

  return (
    <div class="flex flex-col items-center gap-1.5">
      <svg ref={svg!} viewBox="0 0 100 100" class="h-16 w-16">
        {/* Track */}
        <circle
          cx="50" cy="50" r="42"
          stroke="rgba(255,255,255,0.04)"
          stroke-width="5"
          fill="none"
        />
        {/* Glow behind value arc */}
        <circle
          cx="50" cy="50" r="42"
          stroke={gaugeColor()}
          stroke-width="8"
          fill="none"
          stroke-linecap="round"
          stroke-dasharray={String(C)}
          stroke-dashoffset={String(C * (1 - pct()))}
          transform="rotate(-90 50 50)"
          style={{ transition: "stroke-dashoffset 600ms ease, stroke 600ms ease" }}
          opacity="0.15"
          filter="url(#glow)"
        />
        {/* Value arc */}
        <circle
          cx="50" cy="50" r="42"
          stroke={gaugeColor()}
          stroke-width="5"
          fill="none"
          stroke-linecap="round"
          stroke-dasharray={String(C)}
          stroke-dashoffset={String(C * (1 - pct()))}
          transform="rotate(-90 50 50)"
          style={{ transition: "stroke-dashoffset 600ms ease, stroke 600ms ease" }}
        />
        {/* Value readout */}
        <text
          x="50" y="48"
          text-anchor="middle"
          dominant-baseline="central"
          class="font-display"
          font-size="16"
          font-weight="900"
          fill="var(--color-text-primary)"
        >
          {props.value.toFixed(1)}
        </text>
        <text
          x="50" y="62"
          text-anchor="middle"
          class="font-mono"
          font-size="7"
          fill="var(--color-text-dim)"
          letter-spacing="0.1em"
        >
          {props.unit ?? ""}
        </text>
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg>
      <div class="font-mono text-[8px] font-medium uppercase tracking-[0.15em] text-[var(--color-text-dim)]">
        {props.label}
      </div>
    </div>
  );
}
